import externalLinks from '@/configs/external-links';

export default [
  {
    name: 'footer.navigation.0',
    href: externalLinks.about,
    target: '_blank',
  },
  {
    name: 'footer.navigation.1',
    href: externalLinks.terms,
    target: '_blank',
  },
  // {
  //   name: 'footer.navigation.2',
  //   to: routes.SECURITY,
  // },
  {
    name: 'footer.navigation.3',
    href: externalLinks.policy,
    target: '_blank',
  },
];
